import { useMemo, useState } from 'react';
import { Button, Box } from '@mui/material';
import { useTranslate, useRecordContext } from 'react-admin';
import { useFormContext } from 'react-hook-form';
import { GrayDateInputWithUpperLabel } from './GrayDateInputWithUpperLabel';

const textLinkSx = {
  p: 0,
  m: 0,
  minWidth: 0,
  minHeight: 0,
  textTransform: 'none',
  textDecoration: 'underline',
  justifyContent: 'flex-start',
  fontWeight: 'normal',
  fontSize: 'inherit',
  lineHeight: 'inherit',
  '&:hover': {
    textDecoration: 'underline',
    backgroundColor: 'transparent',
  },
} as const;

export const PlannedRenewalDateInputField = () => {

  const translate = useTranslate();
  const record = useRecordContext();
  const { setValue } = useFormContext();

  const [addPlannedRenewalDateClicked, setAddPlannedRenewalDateClicked] = useState(false);
  const [removedPlannedRenewalDate, setRemovedPlannedRenewalDate] = useState(false);
  const showPlannedRenewalDateField = useMemo(() => {

    return (record && (record.plannedRenewalDate || addPlannedRenewalDateClicked)) && !removedPlannedRenewalDate;

  }, [record, addPlannedRenewalDateClicked, removedPlannedRenewalDate]);

  const clearPlannedRenewalDate = () => {

    setValue('plannedRenewalDate', null);
    setRemovedPlannedRenewalDate(true);

  };

  if (!showPlannedRenewalDateField) {

    return (
      <Button
        variant="text"
        color="primary"
        disableRipple
        sx={textLinkSx}
        onClick={() => {

          setAddPlannedRenewalDateClicked(true);
          setRemovedPlannedRenewalDate(false);

        }}
      >
        {translate('resources.security-inventory-items.text.add_planned_renewal_date')}
      </Button>
    );

  }

  return (
    <Box sx={{ display: 'flex', flexDirection: 'column', mb: 1 }}>
      <GrayDateInputWithUpperLabel
        source="plannedRenewalDate"
        label="resources.security-inventory-items.fields.planned_renewal_date"
        helperText={false}
      />
      <Button
        variant="text"
        color="primary"
        disableRipple
        sx={textLinkSx}
        onClick={clearPlannedRenewalDate}
      >
        {translate('resources.security-inventory-items.text.remove_planned_renewal_date')}
      </Button>
    </Box>
  );

};
